/**
 * Stories implemented in the ResourceCard component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { TextButton, Text, Heading } from '@zillow/constellation-10';
import { FC, useCallback, useState } from 'react';
import dynamic from 'next/dynamic';

import { ResourceCardLayout } from 'src/experiences/MortgageDashboard/modules/ResourceCard/common/ResourceCardLayout';
import { CYPRESS_INTEGRATION_TEST_IDS } from 'src/common/constants';
import { setCypressID } from 'src/utils/setCypressID';

import { FirstPartyResourceCardPropsSuperSet } from 'src/experiences/MortgageDashboard/modules/ResourceCard/types';
const FirstPartyVerifiedPreapprovalResourceCardModal = dynamic(async () => {
    const { FirstPartyVerifiedPreapprovalResourceCardModal } = await import(
        /* webpackChunkName: "FirstPartyVerifiedPreapprovalResourceCardModal" */
        './FirstPartyVerifiedPreapprovalResourceCardModal'
    );
    return FirstPartyVerifiedPreapprovalResourceCardModal;
});

const { VERIFIED_PRE_APPROVAL } = CYPRESS_INTEGRATION_TEST_IDS.MORTGAGE_DASHBOARD.EXPERIENCES;

export const FirstPartyVerifiedPreApprovalResourceCard: FC<FirstPartyResourceCardPropsSuperSet> = ({
    trackPrimaryCTAClick,
    trackCloseButtonClick,
    trackOutsideModalClick,
    trackModalPrimaryCTAClick,
    onStartApplication,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);

    return (
        <ResourceCardLayout
            title={
                <Heading
                    level={4}
                    fontFamily="heading"
                    {...setCypressID(VERIFIED_PRE_APPROVAL.RESOURCE_CARD.TITLE)}
                    textStyle="responsive.heading-md">
                    Back your offer with proof
                </Heading>
            }
            copy={
                <Text>
                    A Verified Pre-approval letter shows sellers you’re serious, prepared, and already working with a
                    lender to finance your purchase.
                </Text>
            }
            cta={
                <TextButton
                    {...setCypressID(VERIFIED_PRE_APPROVAL.RESOURCE_CARD.CTA)}
                    textStyle="body-bold"
                    onClick={() => {
                        trackPrimaryCTAClick();
                        setIsModalOpen(true);
                    }}>
                    Read more
                </TextButton>
            }
            modal={
                <>
                    {isModalOpen && (
                        <FirstPartyVerifiedPreapprovalResourceCardModal
                            isOpen
                            trackModalPrimaryCTAClick={() => {
                                trackModalPrimaryCTAClick && trackModalPrimaryCTAClick();
                            }}
                            onPrimaryModalCTAClick={() => {
                                setIsModalOpen(false);
                                onStartApplication();
                            }}
                            trackCloseButtonClick={trackCloseButtonClick}
                            trackOutsideModalClick={trackOutsideModalClick}
                            onClose={closeModal}
                        />
                    )}
                </>
            }
        />
    );
};
